import { stringIsNullOrWhitespace } from '@/helpers/stringHelpers';

export class SelectOption {
  readonly #value: string;
  readonly #label?: string;

  constructor(value: string, label?: string) {
    this.#value = value;
    this.#label = label;
  }

  get value(): string {
    return this.#value;
  }

  get label(): string {
    return !stringIsNullOrWhitespace(this.#label) ? this.#label as string : this.#value;
  }
}
